export const fetchRandomAdvice = async () => {
    const res = await fetch("https://api.adviceslip.com/advice", { cache: "no-store" })
    return await res.json()
}